import { ReportStationSummaryDtoSchema } from "@report/data/dto/report-station.dto.ts";
import * as z from "zod";

const ReportPoisVisitedRowDtoSchema = z
    .object({
        from: z.number(),
        station_id: z.number(),
        time: z.number().nullable(),
        to: z.number().nullable(),
    })
    .readonly();

const ReportStationPoisVisitedDtoSchema = z
    .object({
        // eslint-disable-next-line id-denylist
        data: z.array(ReportPoisVisitedRowDtoSchema),
        station: ReportStationSummaryDtoSchema,
    })
    .readonly();

export const ReportPoisVisitedDtoSchema = z
    .object({
        // eslint-disable-next-line id-denylist
        data: z.record(z.string(), ReportStationPoisVisitedDtoSchema),
        target_stations: z.record(z.string(), ReportStationSummaryDtoSchema),
    })
    .readonly();

export type ReportPoisVisitedDto = z.output<typeof ReportPoisVisitedDtoSchema>;
